import isMobileBrowser from 'is-mobile'
import { PropsWithChildren } from 'react'

import { Box, Text } from '@domain-group/suit-theme'

import { IconDefinition } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface InvoiceDetailProps {
  boxProps?: object,
  icon?: IconDefinition,
  title: string,
  value?: string,
}

const InvoiceDetail = (props: PropsWithChildren<InvoiceDetailProps>) => {
  const {
    boxProps, children, icon, title, value,
  } = props

  const isMobile = isMobileBrowser()

  const borderProps = isMobile
    ? { borderBottom: '1px solid' }
    : { borderRight: '1px solid' }

  return (
    <Box
      padding="large"
      {...borderProps}
      {...boxProps}
      borderColor="lineColor"
    >
      {!!icon && (
        <FontAwesomeIcon
          icon={icon}
          style={{
            marginRight: 16,
            paddingTop: 8,
          }}
        />
      )}

      <Box flexDirection="column">
        <Text
          color="bodyFontLightColor"
          fontSize="xsmall"
          marginBottom="medium"
          variant="twoLineEllipsis"
        >
          {title}
        </Text>

        {children}

        {value && <Text fontSize="small">{value || ''}</Text>}
      </Box>
    </Box>
  )
}

export default InvoiceDetail
